/**
 * Mapper pour les valeurs de position du logo
 * Convertit entre le format Prisma (SCREAMING_SNAKE_CASE) et le format UI (kebab-case)
 */

// Type Prisma (backend)
export type LogoPositionPrisma =
  | 'TOP_LEFT'
  | 'TOP_CENTER'
  | 'TOP_RIGHT'
  | 'BOTTOM_LEFT'
  | 'BOTTOM_RIGHT';

// Type UI (frontend)
export type LogoPositionUI =
  | 'top-left'
  | 'top-center'
  | 'top-right'
  | 'bottom-left'
  | 'bottom-right';

/**
 * Convertit une position Prisma (SCREAMING_SNAKE_CASE) vers UI (kebab-case)
 */
export function prismaToUI(position: LogoPositionPrisma | null | undefined): LogoPositionUI {
  if (!position) return 'top-left';

  const mapping: Record<LogoPositionPrisma, LogoPositionUI> = {
    TOP_LEFT: 'top-left',
    TOP_CENTER: 'top-center',
    TOP_RIGHT: 'top-right',
    BOTTOM_LEFT: 'bottom-left',
    BOTTOM_RIGHT: 'bottom-right',
  };

  return mapping[position] || 'top-left';
}

/**
 * Convertit une position UI (kebab-case) vers Prisma (SCREAMING_SNAKE_CASE)
 */
export function uiToPrisma(position: LogoPositionUI | null | undefined): LogoPositionPrisma {
  if (!position) return 'TOP_LEFT';

  const mapping: Record<LogoPositionUI, LogoPositionPrisma> = {
    'top-left': 'TOP_LEFT',
    'top-center': 'TOP_CENTER',
    'top-right': 'TOP_RIGHT',
    'bottom-left': 'BOTTOM_LEFT',
    'bottom-right': 'BOTTOM_RIGHT',
  };

  return mapping[position] || 'TOP_LEFT';
}
